/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var app   = require('mag-app'),
    $node = document.getElementById('info'),
    $text = document.getElementById('infoText'),
    $icon = document.getElementById('infoIcon'),
    $dualMonoImg = document.getElementById('dualMono'),
    visible = false,
    DELAY = 5000,
    timeout,
    dualMonoTimeout;

$dualMonoImg.src = 'img/' + ( app.metrics.height === 1080 ? 1080 : 720 ) + '/dualmono.png';

app.addListener('route', function ( event ) {
    if ( event.to === app.pages.main && visible ) {
        $node.classList.remove('bg');
    } else if ( event.to === app.pages.clear && visible ) {
        $node.classList.add('bg');
    }
});

/**
 * InfoWIdget caller
 */
module.exports = {
    /**
     * Display info on infoWIdget
     *
     * @param {Object} config - configto display
     * @param {string} [config.text] -  text to show
     * @param {string} [config.icon] - icon to show
     */
    displayInfo: function ( config ) {
        if ( app.activePage === app.pages.main ) {
            $node.classList.remove('bg');
        } else {
            $node.classList.add('bg');
        }
        $node.classList.add('visible');
        visible = true;
        $text.innerText = config.text || '';
        $icon.innerText = config.icon || '';
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            $node.classList.remove('visible');
            $text.innerText = '';
            $icon.innerText = '';
            visible = false;
        }, DELAY);

    },
    showDualMono: function () {
        clearTimeout(dualMonoTimeout);
        $dualMonoImg.classList.add('active');

        dualMonoTimeout = setTimeout(function () {
            $dualMonoImg.classList.remove('active');
        }, DELAY);
    }
};
